import { render, staticRenderFns } from "./BranchDensityMap.vue?vue&type=template&id=90edf5b6&scoped=true&"
import script from "./BranchDensityMap.vue?vue&type=script&lang=js&"
export * from "./BranchDensityMap.vue?vue&type=script&lang=js&"
import style0 from "./BranchDensityMap.vue?vue&type=style&index=0&id=90edf5b6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90edf5b6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VChip,VIcon,VSpacer})
